

















import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import WsResponseModel from "../../../api/dataSource/api/SchemaBuilderServer/Models/WsResponseModel";
import EmployeesListResponse from "../../../api/dataSource/api/EducationSystem/PublicWeb/Api/Models/EmployeeModels/EmployeesListResponse";
import EmployeesType from "../../../api/dataSource/api/EducationSystem/PublicWeb/Api/Enums/EmployeesType";
import DepartmentListItem from "../../../api/dataSource/api/EducationSystem/PublicWeb/Api/Models/EmployeeModels/DepartmentListItem";
@Component
export default class PageDepartmentComponent extends Vue {
  type: EmployeesType = EmployeesType.Teachers;
  departmentModel: WsResponseModel<DepartmentListItem> = null;
  serviceModel: WsResponseModel<EmployeesListResponse> = null;

  mounted() {
    this.getDepartment();
    this.getEmployees();
  }

  @Watch('$route', { immediate: true, deep: true })
  onChangeUrl(){
    this.getDepartment();
    this.getEmployees(); 
  }

  getDepartment() {
    this.$api.EmployeeService.GetDepartmentEvent.once(
      this.onGetDepartment.bind(this)
    );
    this.$api.EmployeeService.GetDepartment(Number(this.$route.params.id));
  }
  getEmployees() {
    this.$api.EmployeeService.GetEmployeesListEvent.once(
      this.onGetEmployeesList.bind(this)
    );
    this.$api.EmployeeService.GetEmployeesList({
      DepartmentId: Number(this.$route.params.id)
    });
  }

  onGetEmployeesList(response: WsResponseModel<EmployeesListResponse>) {
    if (response.IsSuccess) this.serviceModel = response;
  }

  onGetDepartment(response: WsResponseModel<DepartmentListItem>) {
    if (response.IsSuccess) this.departmentModel = response;
    
        if(response.Value)
          this.$meta.setTitle(response.Value.Name+'' || 'Кафедра');
  }
}
